export default {
  "about": "O nas",
  "about_title": "O nas",
  "access_secret": "Dostopna skrivnost",
  "access_token": "Dostopni žeton",
  "accessibility_animations": "Animacije",
  "accessibility_contrast": "Kontrast",
  "accessibility_font_size": "Velikost pisave",
  "accessibility_title": "Dostopnost",
  "actions": "Dejanja",
  "active": "Aktiven",
  "active_ads": "Aktivni oglasi",
  "active_campaigns": "Aktivne kampanje",
  "ad_code_placeholder": "<script>...</script> ali AdSense slot koda",
  "ad_format": "Oblika oglasa",
  "ad_formats": "Oblike oglasov",
  "ad_management": "Upravljanje oglasov",
  "ad_position_settings": "Nastavitve pozicije oglasov",
  "ad_price_list": "Cenik oglasov",
  "ad_pricing_formats_campaigns": "Cene, oblike, kampanje in sledenje",
  "add": "Dodaj",
  "add_api_keys": "Dodajte API ključe v zavihku Nastavitve",
  "address": "Naslov",
  "admin": "Admin",
  "adminPanel": "Admin plošča",
  "admin_ab_testing_title": "A/B Testiranje",
  "admin_accent": "Poudarek",
  "admin_accent_color": "Barva poudarka",
  "admin_action": "Dejanje",
  "admin_activate": "Aktiviraj",
  "admin_active_feeds": "Aktivni viri",
  "admin_active_label": "AKTIVNO",
  "admin_active_now": "Aktivno zdaj",
  "admin_active_subscribers": "Aktivni naročniki",
  "admin_ad_performance": "Učinkovitost oglasov",
  "admin_add_feed": "Dodaj vir",
  "admin_add_tag": "Dodaj oznako",
  "admin_admins": "Administratorji",
  "admin_advertisements": "Oglasi",
  "admin_advertiser_email": "E-pošta oglaševalca",
  "admin_advertiser_name": "Ime oglaševalca",
  "admin_affiliate_links": "Partnerske povezave",
  "admin_ai_content_title": "Obdelava vsebine z umetno inteligenco",
  "admin_ai_prompt_settings": "Nastavitve ukazov in modelov AI",
  "admin_analytics_title": "Analitika",
  "admin_api_latency": "Zaostanek API",
  "admin_api_server": "API strežnik",
  "admin_article_actions": "Dejanja",
  "admin_article_category": "Kategorija",
  "admin_article_published": "Objavljeno",
  "admin_article_selector": "Izbirnik člankov (CSS, npr. article.news)",
  "admin_article_views": "Ogledi",
  "admin_articles_count": "Članki",
  "admin_articles_title": "Članki",
  "admin_author_change_failed": "Sprememba avtorja ni uspela.",
  "admin_authors_title": "Avtorji",
  "admin_auto": "AUTO",
  "admin_auto_save_draft": "Samodejno shrani kot osnutek",
  "admin_avg_seo_score": "Povprečna SEO ocena",
  "admin_bio": "Biografija",
  "admin_blog_manage": "Upravljajte objave na blogu z bogatim urejevalnikom vsebine",
  "admin_blog_title": "Blog",
  "admin_brand_theme": "Blagovna znamka in tema",
  "admin_branding_desc": "Prilagodi videz strani (samo sistemski administrator)",
  "admin_branding_title": "Modul za rebranding",
  "admin_breaking_ticker": "Trenutne Novice Ticker",
  "admin_browser": "Brskalnik",
  "admin_browsers": "Brskalniki",
  "admin_bug_reports": "Poročila napak",
  "admin_bulk_delete_failed": "Skupinsko brisanje ni uspelo.",
  "admin_bulk_operations": "Skupinske operacije",
  "admin_categories_grid": "Mreža Kategorij",
  "admin_choose_gallery": "Izberite iz galerije",
  "admin_churn_prediction": "Napoved odhoda",
  "admin_classic_portal": "Klasični Novičarski Portal",
  "admin_classifieds": "Oglasi",
  "admin_clear_log": "Počisti dnevnik",
  "admin_click_button": "Kliknite gumb",
  "admin_collection_stats": "Statistika zbirk",
  "admin_color_scheme": "Barvna shema",
  "admin_columnist": "Kolumnist",
  "admin_comments": "Komentarji",
  "admin_competitor_monitoring": "Spremljanje konkurence",
  "admin_confirm_action": "Ste prepričani?",
  "admin_content_calendar_title": "Koledar Vsebine",
  "admin_content_filter": "Vsebinski filtri",
  "admin_content_stats": "Statistika vsebine",
  "admin_contributor": "Sodelavec",
  "admin_coordinates": "Koordinate",
  "admin_copy_ip": "Kopiraj IP naslov",
  "admin_copy_text": "Kopiraj",
  "admin_core_services": "Osnovne storitve",
  "admin_countries": "Države",
  "admin_cpc": "CPC (EUR)",
  "admin_crawl_now": "Preišči zdaj",
  "admin_create_author": "Ustvari avtorja",
  "admin_create_manage_promo": "Ustvari in upravljaj promocijske kode",
  "admin_create_voucher": "Ustvari bon",
  "admin_custom_meta": "Prilagojena Meta",
  "admin_dashboard_title": "Nadzorna plošča",
  "admin_database": "Baza podatkov",
  "admin_db_backup": "Varnostna kopija baze podatkov",
  "admin_db_latency": "Zaostanek DB",
  "admin_db_name": "Ime baze podatkov",
  "admin_db_size": "Velikost DB",
  "admin_default": "PRPrivzeto",
  "admin_default_language": "Privzeti jezik",
  "admin_device": "Naprava",
  "admin_devices": "Naprave",
  "admin_discount": "Popust",
  "admin_disk_usage": "Uporaba diska",
  "admin_docs_api_ref": "Referenca API",
  "admin_docs_download_pdf": "Prenesi PDF",
  "admin_docs_faq": "Pogosta vprašanja",
  "admin_docs_getting_started": "Začetek",
  "admin_docs_implemented": "Implementirano",
  "admin_docs_no_pages": "Še ni dokumentacijskih strani",
  "admin_docs_order": "Vrstni red",
  "admin_docs_title": "Dokumentacija",
  "admin_doktor_earnings": "Doktor zaslužek",
  "admin_draft_articles": "Osnutki člankov",
  "admin_dynamic_pricing": "Dinamično določanje cen",
  "admin_edit_in_cms": "Uredi v CMS",
  "admin_editor_role": "Urednik",
  "admin_export_csv": "Izvozi CSV",
  "admin_favicon": "Ikona zaznamka",
  "admin_feed_crawler": "Pajek za vire",
  "admin_feed_name": "Ime vira",
  "admin_feed_url": "URL vira",
  "admin_feeds_title": "RSS viri",
  "admin_file": "Datoteka",
  "admin_fixed_amount": "Fiksni znesek",
  "admin_frozen": "Zamrznjeno",
  "admin_full_name": "Polno ime",
  "admin_general": "Splošno",
  "admin_google_search_console": "Google Search Console",
  "admin_grade": "Ocena",
  "admin_health_title": "Preverjanje zdravja",
  "admin_high_leads": "Visokovredni vodi",
  "admin_import_title": "Uvozna platforma Croatia Times",
  "admin_index_now": "IndexNow",
  "admin_integrations": "Integracije",
  "admin_job_postings": "Delovna mesta",
  "admin_joined": "Pridružil se",
  "admin_keywords": "Ključne besede",
  "admin_landing_title": "Ciljne strani",
  "admin_last_submissions": "Zadnje predložitve",
  "admin_live_analytics": "Živa analitika",
  "admin_live_analytics_title": "Analitika v živo",
  "admin_llm_model": "Model LLM",
  "admin_manage_feeds": "Upravljaj vire",
  "admin_mass_management": "Upravljanje množice člankov",
  "admin_max_articles": "Max. člankov",
  "admin_media_storage": "Shranjevanje medijev",
  "admin_memory": "Pomnilnik",
  "admin_menu_manager": "Upravitelj menija",
  "admin_meta_description": "Meta opis",
  "admin_monetization_title": "Nadzorna plošča monetizacije",
  "admin_mysql_db": "MySQL baza podatkov",
  "admin_mysql_host": "Gostitelj MySQL",
  "admin_nav_ab_testing": "A/B testiranje",
  "admin_nav_ads": "Upravljanje oglasov",
  "admin_nav_ads_report": "Poročilo o oglasih",
  "admin_nav_adsense": "Nastavitve AdSense",
  "admin_nav_advanced_analytics": "Napredna analitika",
  "admin_nav_affiliates": "Povezave partnerjev",
  "admin_nav_ai_content": "Obdelava vsebin z AI",
  "admin_nav_amp": "AMP in Google Discover",
  "admin_nav_analytics": "Analitika",
  "admin_nav_analytics_ai": "Analitika & AI",
  "admin_nav_articles": "Članki",
  "admin_nav_audit_log": "Dnevnik revizij",
  "admin_nav_authors": "Avtorji",
  "admin_nav_blog": "Blog",
  "admin_nav_branding": "Preoblikovanje blagovne znamke",
  "admin_nav_breaking_news": "Nujne / Flash novice",
  "admin_nav_bulk_operations": "Skupinske operacije",
  "admin_nav_categories": "Kategorije",
  "admin_nav_chat_sessions": "Seje klepeta",
  "admin_nav_churn_prediction": "Napovedovanje odhoda",
  "admin_nav_classifieds": "Mali oglasi",
  "admin_nav_comments": "Komentarji",
  "admin_nav_competitor_monitoring": "Spremljanje konkurence",
  "admin_nav_content": "Vsebina",
  "admin_nav_content_calendar": "Koledar vsebin",
  "admin_nav_county_map": "Zemljevid okrožij",
  "admin_nav_crypto": "Kripto pripomoček",
  "admin_nav_dashboard": "Nadzorna plošča",
  "admin_nav_db_backup": "Podatkovna baza",
  "admin_nav_docs": "Dokumentacija",
  "admin_nav_doktor_earnings": "Zaslužek Doktorja",
  "admin_nav_duplicate_detection": "Zaznavanje dvojnikov",
  "admin_nav_editorial": "Uredniško",
  "admin_nav_editorial_workflow": "Uredniški potek dela",
  "admin_nav_email_campaigns": "E-poštne kampanje",
  "admin_nav_feeds": "RSS viri",
  "admin_nav_finance": "Finance",
  "admin_nav_health": "Zdravje sistema",
  "admin_nav_heatmaps": "Toplotna karta branja",
  "admin_nav_import": "Uvoz",
  "admin_nav_invoices": "Računi",
  "admin_nav_job_ads": "Oglasi za delo",
  "admin_nav_landing_pages": "Ciljne strani",
  "admin_nav_live_analytics": "Analitika v živo",
  "admin_nav_management": "Upravljanje",
  "admin_nav_marketing": "Trženje",
  "admin_nav_media": "Mediji",
  "admin_nav_menu_manager": "Upravljalnik menijev",
  "admin_nav_micropayments": "Mikroplačila",
  "admin_nav_monetization": "Monetizacija",
  "admin_nav_newsletter": "E-novice",
  "admin_nav_newsletter_digest": "Povzetek novic",
  "admin_nav_pages": "Strani",
  "admin_nav_payments": "Plačila",
  "admin_nav_performance_forecast": "Napoved delovanja",
  "admin_nav_photo_verification": "Preverjanje fotografij",
  "admin_nav_portal_toggle": "Upravljanje portala",
  "admin_nav_portals": "Portali",
  "admin_nav_pricing": "Cenik",
  "admin_nav_promo_codes": "Promocijske kode",
  "admin_nav_push_notifications": "Obvestila potiskanja",
  "admin_nav_quizzes": "Kvizzi",
  "admin_nav_recommendations": "Priporočila vsebine",
  "admin_nav_reports": "Poročila o vsebini",
  "admin_nav_sanitization": "Čiščenje vsebin",
  "admin_nav_scheduler": "Načrtovalnik vsebin",
  "admin_nav_security": "Varnost",
  "admin_nav_seo_dashboard": "SEO nadzorna plošča",
  "admin_nav_seo_distribution": "SEO in distribucija",
  "admin_nav_series": "Serije člankov",
  "admin_nav_settings": "Nastavitve",
  "admin_nav_social": "Družbeni mediji",
  "admin_nav_social_scheduler": "Načrtovalnik objav",
  "admin_nav_sponsored": "Sponzorirano",
  "admin_nav_sponsored_marketplace": "Sponzorska tržnica",
  "admin_nav_subscriptions": "Naročnine",
  "admin_nav_surveys": "Ankete",
  "admin_nav_syndication": "API za združevanje",
  "admin_nav_system": "Sistem",
  "admin_nav_tips": "Napitnine / Donacije",
  "admin_nav_translations": "Prevodi",
  "admin_nav_ugc_review": "Vsebina državljanov",
  "admin_nav_users": "Uporabniki",
  "admin_nav_users_subscriptions": "Uporabniki & Naročnine",
  "admin_nav_versioning": "Zgodovina različic",
  "admin_nav_vibeposao": "Times Posao Portal",
  "admin_nav_vouchers": "Bone / Popusti",
  "admin_nav_widgets": "Pripomočki / Katalogi",
  "admin_new_author_name": "Novo ime avtorja...",
  "admin_new_post": "Nova objava",
  "admin_no_data": "Ni podatkov na voljo",
  "admin_no_icon": "Brez ikone",
  "admin_no_logo": "Brez logotipa",
  "admin_no_pending_reports": "Ni čakajočih poročil",
  "admin_no_published_articles": "Ni najdenih objavljenih člankov",
  "admin_password_field": "Geslo",
  "admin_performance_forecast": "Napoved uspešnosti",
  "admin_photo_verification": "Verifikacija fotografij",
  "admin_plan": "Načrt",
  "admin_platform_audit": "Revizija platforme",
  "admin_portal_toggle": "Upravljanje portala",
  "admin_premium_users": "Premium uporabniki",
  "admin_primary": "Primarna",
  "admin_published_articles": "Objavljeni članki",
  "admin_published_today": "Objavljeno danes",
  "admin_quick_actions": "Hitri ukrepi",
  "admin_recent_articles": "Nedavni članki",
  "admin_role_change_failed": "Posodobitev vloge ni uspela.",
  "admin_search_placeholder": "Iskanje admin...",
  "admin_secondary": "Sekundarna",
  "admin_seo_desc": "Optimizacija vsebine, upravljanje GSC in zemljevidov",
  "admin_seo_title": "Nadzorna plošča SEO",
  "admin_service_requests": "Zahtevki za storitve",
  "admin_set_category": "Nastavi kategorijo",
  "admin_set_featured": "Nastavi izpostavljeno",
  "admin_settings_saved": "Nastavitve shranjene",
  "admin_settings_title": "Nastavitve",
  "admin_short_desc": "Kratek opis",
  "admin_site_identity": "Identiteta strani",
  "admin_site_logo": "Logotip strani",
  "admin_site_settings": "Nastavitve strani",
  "admin_sponsored_marketplace": "Sponzoriran trg",
  "admin_sponsored_title": "Sponzorirani članki",
  "admin_surveys_title": "Ankete",
  "admin_system_status": "Stanje sistema",
  "admin_table_header_actions": "Dejanja",
  "admin_table_header_date": "Datum",
  "admin_table_header_email": "Email",
  "admin_table_header_name": "Ime",
  "admin_table_header_status": "Status",
  "admin_thumbnail_settings_saved": "Nastavitve sličic shranjene",
  "admin_top_articles_views": "Najboljši članki po ogledih",
  "admin_total_articles": "Skupno število člankov",
  "admin_total_users": "Skupno število uporabnikov",
  "admin_total_views": "Skupno število ogledov",
  "admin_ugc_review": "Pregled UGC",
  "admin_username": "Uporabniško ime",
  "admin_users_title": "Uporabniki",
  "admin_version_history": "Zgodovina različic",
  "admin_view_health_report": "Ogled celotnega zdravstvenega poročila",
  "admin_write_new_article": "Napišite nov članek",
  "adsense_client_id": "AdSense ID stranke",
  "adsense_enable_disable": "Omogoči/Onemogoči vse samodejno prikazovanje oglasov",
  "adsense_global_toggle": "AdSense globalno stikalo",
  "adsense_script_code": "AdSense koda skripte",
  "adsense_settings": "AdSense & Pozicije oglasov",
  "advertise_contact_sales": "Kontaktirajte prodajo",
  "advertise_get_started": "Začnite",
  "advertise_reach_audience": "Dosežite naše občinstvo",
  "advertise_title": "Oglasite se pri nas",
  "advertiser": "Oglaševalec",
  "advertiser_analytics": "Analitika oglaševalca",
  "advertiser_email": "E-pošta oglaševalca",
  "advertising": "Oglaševanje",
  "advertising_cookies": "Piškotki za oglaševanje",
  "affiliate_title": "Partnerski program",
  "ago": "nazaj",
  "ai_image_prompt": "AI zahteva za sliko",
  "all": "Vse",
  "all_categories": "Vse kategorije",
  "all_jobs": "Vsa dela",
  "all_rights": "Vse pravice pridržane",
  "all_status": "Vsi statusi",
  "all_types": "Vse vrste",
  "alpha": "Alfa",
  "alreadyHaveAccount": "Že imate račun?",
  "already_have_account": "Že imate račun?",
  "analytics": "Analitika",
  "analytics_cookies": "Analitični piškotki",
  "api_key": "API ključ",
  "api_secret": "API skrivnost",
  "applications": "Prijave",
  "apply": "Uporabi",
  "apply_now": "Prijavi se zdaj",
  "approve": "Odobri",
  "approved": "Odobreno",
  "archive": "Arhiviraj",
  "archived": "Arhivirano",
  "article_content": "Vsebina članka",
  "article_title": "Naslov članka...",
  "article_views": "Ogledi",
  "author": "Avtor",
  "auto_posting": "Avtomatsko objavljanje in družbene integracije",
  "auto_share_articles": "Samodejno deljenje objavljenih člankov na povezanih platformah",
  "avg_ctr": "Povprečen CTR",
  "back": "Nazaj",
  "basic": "Osnovno",
  "be_respectful": "Bodite spoštljivi in vljudni do drugih uporabnikov in predmetov člankov",
  "beta": "Beta",
  "book_ad": "Rezerviraj oglas",
  "booking_details": "Podrobnosti rezervacije",
  "breaking": "NOVE NOVICE",
  "bug_description": "Opis napake",
  "business": "Posel",
  "business_account_id": "ID poslovnega računa",
  "buyer": "Kupec",
  "campaign_details": "Podrobnosti kampanje",
  "campaigns": "Kampanje",
  "cancel": "Prekliči",
  "caption": "Napis",
  "categories": "Kategorije",
  "category": "Kategorija",
  "category_distribution": "Porazdelitev kategorij",
  "category_push_subscribers": "Naročniki na potisne obvestila kategorij",
  "chatbot_placeholder": "Vnesite sporočilo...",
  "chatbot_send": "Pošlji",
  "chatbot_title": "Pomočnik za klepet",
  "choose_plan": "Izberi svoj paket",
  "city": "Mesto",
  "classifieds": "Mali oglasi",
  "classifieds_title": "Mali oglasi",
  "clear": "Počisti",
  "click_rate": "Stopnja klikov",
  "click_url": "URL za klik (ciljni)",
  "clicks": "Kliki",
  "client_id": "ID stranke",
  "client_secret": "Skrivnost stranke",
  "close": "Zapri",
  "code": "Koda",
  "commenting_rules": "Pravila komentiranja",
  "comments": "Komentarji",
  "companies": "Podjetja",
  "company": "Podjetje",
  "compose_social_post": "Sestavi objavo na družbenih omrežjih",
  "configure": "Konfiguriraj",
  "configure_position": "Nastavite vsak položaj s prilagojeno sliko transparenta ali kodo oglasa",
  "confirm": "Potrdi",
  "confirm_delete": "Ali ste prepričani, da želite izbrisati?",
  "confirm_password": "Potrdite geslo",
  "congratulations": "Čestitke",
  "contact": "Kontakt",
  "contact_title": "Kontakt",
  "contact_us": "Kontaktirajte nas",
  "content": "Vsebina",
  "cookies": "Piškotki",
  "cookies_title": "Politika piškotkov",
  "copy": "Kopiraj",
  "copyright": "Avtorske pravice",
  "copyright_notice": "Avtorske pravice",
  "count": "Število",
  "country": "Država",
  "cpm": "CPM",
  "create": "Ustvari",
  "create_first_ad": "Ustvari svoj prvi oglas",
  "crypto_change_24h": "Sprememba v 24h",
  "crypto_market_cap": "Tržna kapitalizacija",
  "crypto_price": "Cena",
  "crypto_widget_title": "Kripto",
  "ctr": "CTR",
  "culture": "Kultura",
  "current_plan": "Trenutni paket",
  "custom_ad_code": "Prilagojena koda oglasa",
  "custom_banner_url": "URL prilagojenega transparenta",
  "custom_range": "Prilagojen obseg",
  "daily_budget": "Dnevni proračun",
  "daily_performance": "Dnevna uspešnost",
  "dark_mode": "Temni način",
  "data_viz_title": "Vizualizacija podatkov",
  "date": "Datum",
  "dating_add_video": "Dodajte kratek video, da vas bodo potencialne tekme lažje spoznale",
  "dating_block": "Blokiraj",
  "dating_boosts": "Pospeški",
  "dating_city": "Mesto",
  "dating_next": "Naprej",
  "dating_personality_quiz": "Kvizi osebnosti",
  "dating_quiz_completed": "Kvizi osebnosti zaključeni",
  "dating_users": "Uporabniki",
  "dating_verify_identity": "Preverite, da ste resnična oseba",
  "dating_voice_message": "Glasovno sporočilo",
  "days": "dnevi",
  "delete": "Izbriši",
  "delete_failed": "Brisanje ni uspelo.",
  "deleted_successfully": "Uspešno izbrisano",
  "deprecated": "Zastarelo",
  "describe_thumbnail": "Opišite sličico slike za ustvarjanje...",
  "description": "Opis",
  "deselect_all": "Pobriši izbiro",
  "desktop": "Namizje",
  "details": "Podrobnosti",
  "dimensions": "Dimenzije",
  "disabled": "Onemogočeno",
  "dismiss": "Zavrzi",
  "documentation": "Dokumentacija",
  "doktor_add_document": "Dodaj Dokument",
  "doktor_biography": "Biografija",
  "doktor_birth_date": "Datum Rojstva",
  "doktor_chat": "Klepet",
  "doktor_control_date": "Datum Kontrole",
  "doktor_date": "Datum",
  "doktor_diagnosis": "Diagnoza",
  "doktor_enter_name_specialization": "Vnesite ime in vsaj eno specializacijo",
  "doktor_enter_patient_name": "Vnesite ime pacienta",
  "doktor_license_number": "Številka Licence",
  "doktor_panel": "Panel Zdravnika",
  "doktor_patient_name": "Ime Pacienta",
  "doktor_text_min_chars": "Besedilo mora imeti vsaj 50 znakov",
  "doktor_waiting_room": "Čakalnica",
  "dont_have_account": "Nimate računa?",
  "download": "Prenesi",
  "draft": "Osnutek",
  "duplicate": "Podvoji",
  "duration_days": "Trajanje (dni)",
  "economy": "Gospodarstvo",
  "edit": "Uredi",
  "electronics": "Elektronika",
  "email": "Email",
  "email_address": "E-poštni naslov",
  "email_campaigns": "E-poštne kampanje",
  "email_clicks": "Kliki na e-pošto",
  "email_content": "Vsebina e-pošte...",
  "email_opens": "Odpiranja e-pošte",
  "email_placeholder": "Vaš e-poštni naslov",
  "email_subject": "Zadeva e-pošte",
  "employer": "Delodajalec",
  "enabled": "Omogočeno",
  "end_date": "Datum konca",
  "enter_advertiser_email": "Vnesite vašo e-pošto oglaševalca...",
  "enter_email_to_view": "Za ogled uspešnosti kampanje vnesite zgoraj vašo e-pošto oglaševalca",
  "entertainment": "Zabava",
  "error": "Napaka",
  "error_deleting": "Napaka pri brisanju",
  "error_generating_digest": "Napaka pri ustvarjanju povzetka",
  "error_loading": "Napaka pri nalaganju",
  "error_saving": "Napaka pri shranjevanju",
  "error_saving_settings": "Napaka pri shranjevanju",
  "error_sending": "Napaka pri pošiljanju",
  "error_uploading": "Napaka pri nalaganju",
  "error_uploading_photo": "Nalaganje fotografije ni uspelo",
  "events_calendar": "Koledar dogodkov",
  "excerpt_summary": "Odlomek / Povzetek",
  "experimental": "Eksperimentalno",
  "export": "Izvozi",
  "export_data": "Izvozi podatke",
  "facebook": "Facebook",
  "facebook_login_unavailable": "Prijava s Facebookom ni na voljo",
  "failed_post_comment": "Ni uspelo objaviti komentarja.",
  "feature_flags": "Značilnosti zastavic",
  "feature_job": "Izpostavi delo",
  "featured": "Izpostavljeno",
  "featured_article": "Izbrani članek",
  "featured_duration": "Trajanje izpostavljenosti",
  "featured_image": "Predstavljena slika",
  "featured_jobs": "Izpostavljena delovna mesta",
  "feedback": "Povratne informacije",
  "filter": "Filter",
  "filter_terms_saved": "Pogoji filtra so shranjeni!",
  "find_jobs": "Poišči službe",
  "first": "Prva",
  "first_process_publish": "Najprej obdela in objavi članek",
  "footer_ai": "Ta portal uporablja AI pomoč za izboljšanje uporabniške izkušnje",
  "footer_ai_notice": "Nekatere vsebine so ustvarjene s pomočjo AI - prijavite težave",
  "footer_cat_business": "Posel",
  "footer_cat_culture": "Kultura",
  "footer_cat_health": "Zdravje",
  "footer_cat_news": "Novice",
  "footer_cat_politics": "Politika",
  "footer_cat_sports": "Šport",
  "footer_cat_technology": "Tehnologija",
  "footer_categories": "Kategorije",
  "footer_copyright": "2026 Liber Nostra d.o.o. Vse pravice pridržane.",
  "footer_description": "Croatia Times je vaš zaupanja vreden vir za najnovejše novice, poglobljene analize in privlačne zgodbe iz Hrvaške in širše.",
  "footer_developed_by": "Razvito in vzdrževano z ljubeznijo od",
  "footer_email_placeholder": "Vaš e-poštni naslov",
  "footer_here": "tukaj",
  "footer_hosted_by": "Gosti",
  "footer_link_about": "O nas",
  "footer_link_advertise": "Oglaševanje",
  "footer_link_contact": "Kontakt",
  "footer_link_cookies": "Piškotki",
  "footer_link_imprint": "Impressum",
  "footer_link_privacy": "Pravilnik o zasebnosti",
  "footer_link_submit_news": "Pošlji novice",
  "footer_newsletter_text": "Naročite se na naše novice",
  "footer_quick_links": "Hitre povezave",
  "footer_stay_informed": "Ostanite obveščeni",
  "footer_subscribe": "Naroči se",
  "for_you_personalized": "Personalizirana vsebina glede na vaše interese",
  "for_you_title": "Za vas",
  "forgot_password": "Ste pozabili geslo?",
  "free": "Brezplačno",
  "free_plan": "Brezplačno",
  "from": "Od",
  "full_time": "Polni delovni čas",
  "general": "Splošno",
  "goodbye": "Nasvidenje",
  "hashtags": "Kliči znaki",
  "hashtags_placeholder": "#novice #hrvaška...",
  "header_auto_schedule_active": "Samodejni razpored je aktiven",
  "header_forecast": "Napoved",
  "header_humidity": "Vlažnost",
  "header_live": "V ŽIVO",
  "header_portals_label": "Portali",
  "header_weather_humidity": "Vlažnost",
  "header_weather_wind": "Veter",
  "header_wind": "Veter",
  "health": "Zdravje",
  "hello": "Zdravo",
  "help": "Pomoč",
  "home": "Domov",
  "home_podcast_title": "Tedenski tehnični povzetek: AI v hrvaških startupih",
  "home_video_title": "Znotraj Zagreba: Dokumentarec o uličnoj umetnosti",
  "hours": "ure",
  "import": "Uvozi",
  "impressions": "Prikazi",
  "imprint": "Natisni",
  "imprint_title": "Impressum",
  "inactive": "Neaktiven",
  "info": "Informacije",
  "instagram": "Instagram",
  "invalid_code": "Neveljavna koda. Poskusite znova.",
  "items_selected": "izbrani elementi",
  "job_categories": "Kategorije delovnih mest",
  "job_postings": "Objave za delo",
  "job_seeker": "Iskalec zaposlitve",
  "just_now": "Ravnokar",
  "language": "Jezik",
  "last": "Zadnja",
  "latest_news": "Zadnje novice",
  "legal": "Pravno",
  "lifestyle": "Življenjski slog",
  "lifetime": "Doživljenjsko",
  "light_mode": "Svetli način",
  "linked_email_campaign": "Povezano z email kampanjo",
  "linkedin": "LinkedIn",
  "live_stream": "V živo prenos",
  "load_more": "Naloži več",
  "loading": "Nalaganje...",
  "local": "Lokalno",
  "location": "Lokacija",
  "login": "Prijava",
  "logout": "Odjava",
  "loyalty_available_points": "Razpoložljive točke",
  "loyalty_available_rewards": "Razpoložljive nagrade",
  "loyalty_badges": "Značke",
  "loyalty_consecutive_days": "Zaporedni dnevi",
  "loyalty_error": "Napaka",
  "loyalty_leaderboard": "Lestvica najboljših",
  "loyalty_leaderboard_empty": "Lestvica najboljših je prazna",
  "loyalty_rewards": "Nagrade",
  "loyalty_used_rewards": "Uporabljene nagrade",
  "majstor_categories": "Kategorije",
  "majstor_city": "Mesto",
  "majstor_company_name": "Ime podjetja *",
  "majstor_flexible": "Prilagodljivo",
  "majstor_max_budget": "Najvišji proračun (EUR)",
  "majstor_min_budget": "Najnižji proračun (EUR)",
  "majstor_my_requests": "Moje zahteve",
  "majstor_request_title": "Naslov zahteve *",
  "majstor_service_categories": "Kategorije storitev",
  "majstor_urgent": "Nujno",
  "manage": "Upravljaj",
  "manage_bookings": "Upravljaj rezervacije oglaševalca",
  "mark_as_read": "Označi kot prebrano",
  "marketing_dashboard": "Marketinška Nadzorna Plošča",
  "marketing_live_metrics": "Metike uspešnosti v živo za Croatia Times",
  "marketing_published_articles": "Objavljeni Članki",
  "marketing_registered_users": "Registrirani Uporabniki",
  "marketing_today_views": "Današnji Ogledi",
  "marketing_total_views": "Skupno Število Ogledov",
  "minutes": "minute",
  "missing_translations": "Manjkajoči prevodi",
  "mobile": "Mobilno",
  "more": "Več",
  "most_popular": "Najbolj priljubljeno",
  "most_read": "Najbolj brano",
  "move": "Premakni",
  "must_be_logged_in_purchase": "Za nakup članka se morate prijaviti",
  "myProfile": "Moj profil",
  "my_applications": "Moje prijave",
  "name": "Ime",
  "new": "Novo",
  "new_article": "Nov članek",
  "new_campaign": "Nova kampanja",
  "new_notification": "Novo obvestilo",
  "new_push_notification": "Novo potisno obvestilo",
  "new_verification_sent": "Nova potrditvena koda je bila poslana na vaš email.",
  "news": "Novice",
  "newsletter": "Novice",
  "newsletter_desc": "Naročite se na najnovejše novice",
  "newsletter_only_subscribers": "Samo naročniki",
  "newsletter_subscribers": "Naročniki na novice",
  "next": "Naslednje",
  "no": "Ne",
  "noAccount": "Nimate računa?",
  "no_articles": "Ni najdenih člankov",
  "no_bookings": "Ni najdenih rezervacij",
  "no_campaigns": "Ni kampanj",
  "no_data": "Podatki niso na voljo",
  "no_items": "Ni najdenih elementov",
  "no_linked_campaign": "Ni povezane kampanje",
  "no_notifications": "Ni obvestil",
  "no_results": "Ni najdenih rezultatov",
  "no_scheduled_posts": "Ni načrtovanih objav še",
  "no_sent_notifications": "Ni poslanih obvestil",
  "none": "Noben",
  "note": "Opomba",
  "notification_body": "Besedilo obvestila",
  "notification_title": "Naslov obvestila",
  "notifications": "Obvestila",
  "of": "od",
  "off": "Izklopljeno",
  "offline": "Nedosegljiv",
  "on": "Vklopljeno",
  "one_time": "enkratno",
  "online": "Na spletu",
  "open_rate": "Stopnja odpiranja",
  "optional": "Izbirno",
  "options": "Možnosti",
  "orContinueWith": "Ali nadaljujte z",
  "or_continue_with": "Ali nadaljujte z",
  "order": "Naročilo",
  "other": "Drugo",
  "page": "Stran",
  "part_time": "Polovični delovni čas",
  "password": "Geslo",
  "paste": "Prilepi",
  "pause": "Zaustavi",
  "payment_error": "Napaka pri plačilu",
  "payment_processing": "Obdelava plačila...",
  "payment_success": "Plačilo je bilo uspešno!",
  "payment_thank_you": "Hvala za vaš nakup!",
  "pending": "V čakanju",
  "pending_approval": "Čakajoče na odobritev",
  "per_month": "/mesec",
  "per_page": "na stran",
  "percentage": "Odstotek",
  "performance": "Uspešnost",
  "phone": "Telefon",
  "platforms": "Platforme",
  "politics": "Politika",
  "poll_results": "Rezultati",
  "poll_total_votes": "Skupno glasov",
  "poll_vote": "Glasuj",
  "popular": "Priljubljeno",
  "post_comment": "Objavi komentar",
  "post_error": "Napaka pri objavi",
  "post_job": "Objavi delo",
  "post_now": "Objavi zdaj",
  "powered_by": "Omogoča",
  "premium": "Premium",
  "preview": "Predogled",
  "previous": "Prejšnje",
  "price": "Cena",
  "privacy": "Zasebnost",
  "privacy_title": "Politika zasebnosti",
  "proceed_to_payment": "Nadaljuj na plačilo",
  "profile": "Profil",
  "profile_admin_access": "Hitri Dostop Admina",
  "profile_analytics": "Analitika",
  "profile_articles": "Članki",
  "profile_dashboard": "Nadzorna Plošča",
  "profile_edit": "Uredi Profil",
  "profile_verified": "Profil preverjen!",
  "promo_success": "Promocijska koda je bila uspešno uporabljena!",
  "promote_job": "Promoviraj delo",
  "publish": "Objavi",
  "published": "Objavljeno",
  "published_date": "Objavljeno",
  "push_notifications": "Potisna obvestila",
  "read": "Prebrano",
  "read_more": "Preberi več",
  "real_estate": "Nepremičnine",
  "recent": "Nedavno",
  "recipes_add_first": "Dodaj svoj prvi recept",
  "recipes_browse_all": "Prebrskaj vse recepte",
  "recipes_category": "Kategorija",
  "recipes_cook_time": "Čas Kuhanja",
  "recipes_easy": "Enostavno",
  "recipes_featured": "Prikazani Recepti",
  "recipes_filters": "Filtri",
  "recipes_ingredient": "Sestavina",
  "recipes_ingredients": "Sestavine",
  "recipes_instructions": "Navodila",
  "recipes_latest": "Zadnji Recepti",
  "recipes_most_popular": "Najbolj Priljubljeni Recepti",
  "recipes_prep_time": "Čas Priprave",
  "recipes_search": "Išči recepte...",
  "recipes_servings": "Porcije",
  "recipes_title": "Recepti",
  "recommended": "Priporočeno",
  "refresh": "Osveži",
  "region": "Regija",
  "register": "Registracija",
  "reject": "Zavrni",
  "rejected": "Zavrnjeno",
  "related_articles": "Povezani članki",
  "remote": "Na daljavo",
  "remove": "Odstrani",
  "report": "Poročilo",
  "reports": "Poročila",
  "reposting_rules_title": "Pravila za ponovno objavo",
  "required": "Zahtevano",
  "reset": "Ponastavi",
  "restore": "Obnovi",
  "results": "Rezultati",
  "resume": "Nadaljuj",
  "revision_restored": "Različica obnovljena!",
  "salary": "Plača",
  "salary_max": "Najvišja plača",
  "salary_min": "Najnižja plača",
  "save": "Shrani",
  "saved_jobs": "Shranjene službe",
  "saved_successfully": "Uspešno shranjeno",
  "schedule": "Razpored",
  "scheduled": "Načrtovano",
  "science": "Znanost",
  "search": "Iskanje...",
  "search_articles": "Išči članke...",
  "search_placeholder": "Išči...",
  "search_results_for": "Rezultati iskanja za",
  "seconds": "sekunde",
  "see_all": "Poglej vse",
  "select": "Izberi",
  "select_all": "Izberi vse",
  "select_format": "Izberi obliko",
  "seller": "Prodajalec",
  "send_campaign": "Pošlji kampanjo",
  "sent": "Poslano",
  "sent_campaigns": "Poslane kampanje",
  "services": "Storitve",
  "settings": "Nastavitve",
  "share": "Deli",
  "showing": "Prikazano",
  "signIn": "Prijava",
  "signOut": "Odjava",
  "site_name": "Croatia Times",
  "site_subtitle": "Hrvaška Danes",
  "six_digit_code": "6-mestna koda",
  "social_media": "Družbeni mediji",
  "social_scheduler": "Načrtovalnik objav",
  "sort": "Razvrsti",
  "sponsored_marketplace_title": "Sponzoriran trg",
  "sports": "Šport",
  "stable": "Stabilno",
  "start": "Začni",
  "start_date": "Datum začetka",
  "static_about_contact": "Za uredniške poizvedbe, oglaševanje ali splošne informacije obiščite našo",
  "static_about_contact_page": "kontaktno stran",
  "static_about_contact_title": "Kontakt",
  "static_about_lead": "Croatia Times je neodvisni novičarski portal, ki vam prinaša najnovejše novice, analize, komentarje in zgodbe iz Hrvaške in regije. Smo del medijske družine e-mina.eu, z isto ekipo in enakimi vrednotami.",
  "static_about_mission": "Zavezani smo zagotavljanju natančnega, pravočasnega in kakovostnega novinarstva, ki služi javnemu interesu. Naša uredniška ekipa je sestavljena iz izkušenih novinarjev z globokim poznavanjem hrvaških in regionalnih zadev.",
  "static_about_mission_title": "Naše Poslanstvo",
  "static_about_publisher": "Liber Nostra d.o.o. je založnik Croatia Times in e-mina.eu. Podjetje se specializira za digitalne medije in novičarske portale osredotočene na hrvaški trg.",
  "static_about_publisher_title": "Založnik",
  "static_about_standards": "Croatia Times se drži najvišjih novinarskih standardov. Preverjamo dejstva v naših poročilih, jasno označujemo komentarje in analize ter hitro in pregledno popravljamo napake.",
  "static_about_standards_title": "Uredniški Standardi",
  "static_about_team": "Za Croatia Times stoji ekipa izkušenih medijskih strokovnjakov, novinarjev, urednikov in tehničnih strokovnjakov, ki delajo na razvoju platforme in kakovosti vsebin. Naša ekipa je ista, ki stoji za uspešnim portalom e-mina.eu - Mednarodna Novičarska Agencija.",
  "static_about_team_title": "Ekipa",
  "static_about_title": "O Nas - Croatia Times",
  "static_bug_description": "Opis napake",
  "static_bug_description_placeholder": "Opišite, kaj se je zgodilo in kako reproducirati težavo...",
  "static_bug_intro": "Ste našli nekaj, kar ne deluje pravilno? Sporočite nam in bomo hitro popravili.",
  "static_bug_page_url": "URL strani (kjer se je napaka pojavila)",
  "static_bug_screenshot": "Posnetek zaslona (neobvezno)",
  "static_bug_submit": "Pošlji poročilo o napaki",
  "static_bug_submitting": "Pošiljanje...",
  "static_bug_thanks": "Hvala za vaše poročilo! Preučili bomo in odpravili težavo.",
  "static_bug_title": "Poročaj o napaki",
  "static_commenting_intro": "Veseli smo konstruktivne razprave. Da bo naš odsek za komentarje pozitiven in produktiven, upoštevajte ta pravila:",
  "static_commenting_login": "Za komentiranje se morate registrirati in prijaviti v Croatia Times.",
  "static_commenting_rule_1": "Bodite spoštljivi in vljudni do drugih uporabnikov in predmetov člankov.",
  "static_commenting_rule_2": "Brez sovražnega govora, rasizma, seksizma ali katerekoli oblike diskriminacije.",
  "static_commenting_rule_3": "Brez neželene pošte, oglaševanja ali promocijskih vsebin.",
  "static_commenting_rule_4": "Brez dezinformacij ali širjenja nepreverjenih trditev.",
  "static_commenting_rule_5": "Brez osebnih napadov ali nadlegovanja.",
  "static_commenting_rule_6": "Ostanite pri temi in prispevajte k pogovoru.",
  "static_commenting_rule_7": "Brez osebnih ali zaupnih podatkov o tretjih osebah.",
  "static_commenting_title": "Pravila komentiranja",
  "static_commenting_violation": "Komentarji, ki kršijo ta pravila, se lahko odstranijo brez opozorila. Pogosti kršilci so lahko trajno prepovedani.",
  "static_contact_email": "E-pošta",
  "static_contact_message": "Sporočilo",
  "static_contact_message_placeholder": "Vaše sporočilo...",
  "static_contact_name": "Ime",
  "static_contact_name_placeholder": "Vaše ime",
  "static_contact_send": "Pošlji Sporočilo",
  "static_contact_sending": "Pošiljanje...",
  "static_contact_sent_desc": "Odgovorili vam bomo v roku 24 ur.",
  "static_contact_sent_title": "Sporočilo Poslano!",
  "static_contact_subject": "Zadeva",
  "static_contact_subject_placeholder": "Kako vam lahko pomagamo?",
  "static_contact_title": "Kontaktirajte Nas",
  "static_cookies_advertising_text": "Morda bomo uporabljali piškotke Google AdSense za prikazovanje ustreznih oglasov.",
  "static_cookies_advertising_title": "Oglaševalski piškotki",
  "static_cookies_analytics_text": "Google Analytics nam pomaga razumeti, kako obiskovalci uporabljajo našo spletno stran. Podatki so anonimizirani, kjer je to mogoče.",
  "static_cookies_analytics_title": "Analitični piškotki",
  "static_cookies_managing_text": "Piškotke lahko upravljate prek nastavitev vašega brskalnika. Onemogočanje nujnih piškotkov lahko vpliva na delovanje spletne strani.",
  "static_cookies_managing_title": "Upravljanje piškotkov",
  "static_cookies_necessary_text": "Ti so potrebni za delovanje spletne strani (prijavne seje, nastavitve teme). Onemogočiti jih ni mogoče.",
  "static_cookies_necessary_title": "Nujni piškotki",
  "static_cookies_title": "Politika piškotkov",
  "static_cookies_types_title": "Vrste piškotkov, ki jih uporabljamo",
  "static_cookies_what_text": "Piškotki so majhne besedilne datoteke, ki so shranjene na vaši napravi, ko obiščete spletno stran. Pomagajo si zapomniti vaše nastavitve in razumeti, kako uporabljate spletno stran.",
  "static_cookies_what_title": "Kaj so piškotki",
  "static_imprint_ads_email": "E-pošta (oglaševanje):",
  "static_imprint_ai_notice": "Nekatero vsebino generira AI tehnologija. Napake ali neprimerno vsebino prijavite na",
  "static_imprint_contact": "Kontakt",
  "static_imprint_copyright": "Avtorske Pravice",
  "static_imprint_copyright_text": "Vsa vsebina objavljena na Croatia Times je zaščitena z avtorskimi pravicami. Liber Nostra d.o.o. si pridržuje vse pravice do besedila, slik in multimedijske vsebine objavljene na tej strani. Podrobne informacije o pravilih ponovnega objavljanja vsebine so na voljo na",
  "static_imprint_ct_desc": "Novičarski portal Croatia Times",
  "static_imprint_disclaimer": "Odveza odgovornosti",
  "static_imprint_disclaimer_text": "Kljub skrbnemu nadzoru vsebine, ne sprejemamo odgovornosti za zunanje povezave. Njihovi upravljavci so izključno odgovorni za njihovo vsebino.",
  "static_imprint_editorial_email": "E-pošta (uredništvo):",
  "static_imprint_emina_desc": "Mednarodna Novičarska Agencija",
  "static_imprint_general_email": "E-pošta (splošne poizvedbe):",
  "static_imprint_last_updated": "Zadnja posodobitev: februar 2026",
  "static_imprint_or_via": "ali prek naše",
  "static_imprint_publisher": "Založnik",
  "static_imprint_registered": "Registrirano v Republiki Hrvaški",
  "static_imprint_reposting_page": "stran s pravili ponovnega objavljanja",
  "static_imprint_responsible": "Odgovorni za vsebino",
  "static_imprint_responsible_text": "Uredniška ekipa Croatia Times / Liber Nostra d.o.o.",
  "static_imprint_title": "Impresum",
  "static_imprint_websites": "Spletne Strani",
  "static_privacy_controller": "Upravljavec podatkov: Liber Nostra d.o.o.",
  "static_privacy_cookies_text": "Za delovanje in analitiko uporabljamo piškotke. Za podrobnosti si oglejte našo politiko piškotkov.",
  "static_privacy_cookies_title": "Piškotki",
  "static_privacy_data_text": "Zbiramo podatke, ki jih neposredno posredujete (ime, e-pošta ob prijavi), podatke o uporabi (obiskane strani, prebrani članki) in tehnične podatke (IP naslov, vrsta brskalnika).",
  "static_privacy_data_title": "Podatki, ki jih Zbiramo",
  "static_privacy_last_updated": "Zadnja posodobitev: januar 2026",
  "static_privacy_lead": "Croatia Times spoštuje vašo zasebnost in je zavezana varovanju vaših osebnih podatkov.",
  "static_privacy_retention_text": "Vaše podatke hranimo tako dolgo, kot je vaš račun aktiven, ali po potrebi iz pravnih razlogov.",
  "static_privacy_retention_title": "Hramba podatkov",
  "static_privacy_rights_text": "Imate pravico do dostopa, popravka ali izbrisa vaših osebnih podatkov. Obrnite se na nas na",
  "static_privacy_rights_title": "Vaše pravice",
  "static_privacy_title": "Pravilnik o Zasebnosti",
  "static_privacy_usage_text": "Vaše podatke uporabljamo za zagotavljanje našega novičarskega servisa, prilagoditev vaše izkušnje, pošiljanje novic (z vašim soglasjem) in izboljšanje naše platforme.",
  "static_privacy_usage_title": "Kako Uporabljamo Vaše Podatke",
  "static_reposting_copyright_text": "Vsa vsebina, objavljena na Croatia Times, je zaščitena z avtorskimi pravicami. Liber Nostra d.o.o. ima vse pravice do tekstov, slik in multimedije, objavljene na tej spletni strani.",
  "static_reposting_copyright_title": "Avtorske pravice",
  "static_reposting_permission_text": "Za dovoljenje za ponatis vsebine nas kontaktirajte na",
  "static_reposting_permission_title": "Zahteve za dovoljenja",
  "static_reposting_permitted_text": "Povezave do naših člankov lahko delite na družbenih omrežjih in drugih platformah. Kratki citati (do 2 odstavka) se lahko uporabljajo z jasnim navedbo avtorstva in povezavo na izvirni članek.",
  "static_reposting_permitted_title": "Dovoljena uporaba",
  "static_reposting_prohibited_text": "Popolno tiskanje člankov brez pisnega dovoljenja je prepovedano. Slik ne smete ponovno reproducirati brez dovoljenja. Samodejni strganje vsebine je strogo prepovedano.",
  "static_reposting_prohibited_title": "Prepovedana uporaba",
  "static_reposting_title": "Pravila ponovnega objavljanja",
  "static_submit_news_details": "Podrobnosti zgodbe",
  "static_submit_news_details_placeholder": "Opišite novico...",
  "static_submit_news_file_limit_error": "Datoteka presega omejitev",
  "static_submit_news_headline": "Naslov novice",
  "static_submit_news_intro": "Imate novico? Pošljite jo sem in naš uredniški tim jo bo pregledal.",
  "static_submit_news_limit": "Sprejemamo fotografije in videoposnetke do",
  "static_submit_news_photos": "Fotografije / Video (do",
  "static_submit_news_send": "Pošlji novice",
  "static_submit_news_sending": "Pošiljanje...",
  "static_submit_news_source": "Vir / Referenca (neobvezno)",
  "static_submit_news_source_placeholder": "URL ali referenca",
  "static_submit_news_thanks": "Hvala za vašo prijavo! Naša ekipa jo bo kmalu pregledala.",
  "static_submit_news_title": "Pošlji svojo novico",
  "static_submit_news_your_name": "Vaše ime",
  "status": "Status",
  "stop": "Ustavi",
  "submit": "Pošlji",
  "submitNews": "Pošlji novice",
  "submit_bug_title": "Prijavi napako",
  "submit_news": "Pošlji novice",
  "submit_news_title": "Oddaj novico",
  "subscribe": "Naroči se",
  "subscription": "Naročnina",
  "subscription_title": "Naročniški načrti",
  "success": "Uspeh",
  "support": "Podpora",
  "tablet": "Tablica",
  "tags": "Oznake",
  "target_impressions": "Ciljni prikazi",
  "technology": "Tehnologija",
  "template": "Predloga",
  "templates": "Predloge",
  "terms": "Pogoji",
  "thank_you": "Hvala",
  "this_month": "Ta mesec",
  "this_week": "Ta teden",
  "this_year": "Letos",
  "tip": "Nasvet",
  "title": "Naslov",
  "to": "Do",
  "today": "Danes",
  "total": "Skupaj",
  "translate_all": "Prevedi vse",
  "translation_status": "Stanje prevoda",
  "translations": "Prevodi",
  "travel": "Potovanja",
  "trending": "Trend",
  "try_again": "Poskusi znova",
  "twitter": "Twitter",
  "two_factor_auth": "Dvofaktorska avtentikacija",
  "type": "Vrsta",
  "ugc_submit": "Pošlji vsebino",
  "ugc_title": "Portal državljanskega novinarstva",
  "unique_clicks": "Edinstveni kliki",
  "unique_opens": "Edinstvena odpiranja",
  "unknown": "Neznano",
  "unpublish": "Umakni z objave",
  "unread": "Neprebrano",
  "update": "Posodobi",
  "updated_successfully": "Uspešno posodobljeno",
  "upgrade": "Nadgradi",
  "upload": "Naloži",
  "users": "Uporabniki",
  "vehicles": "Vozila",
  "verification_code_sent": "Potrditvena koda je bila poslana na vaš email!",
  "version": "Različica",
  "vibeposao": "Times Posao",
  "view": "Poglej",
  "view_all": "Poglej vse",
  "views": "Ogledi",
  "warning": "Opozorilo",
  "welcome": "Dobrodošli",
  "wish_roles": "Zeleti vloge",
  "working_hours_saved": "Delovne ure so shranjene!",
  "world": "Svet",
  "write_new_article": "Napiši nov članek",
  "yes": "Da",
  "yesterday": "Včeraj",
  "your_bookings": "Vaše rezervacije",
  "youtube": "YouTube"
}
